<template>
	<div class="ps-45" :style="{'top': top, 'position': po }">
	  <img class="wh_88_106 m0-auto mb-16 ml-15" src="../assets/img/bg/nodata.png" alt="">
    <div class="c2 fz-14 text-center">暂无内容</div>
	</div>
</template>
<script>
	export default {
		props: {
      top: {
				type: String,
				default: '50%'
			},
			po: {
				type: String,
				default: 'absolute'
			}
		},
		data() {
			return {

			}
		},
		mounted() {},
		methods: {
     
		}
	}
</script>
<style lang="less" scoped>

</style>
